import { render, staticRenderFns } from "./OrderComplain.vue?vue&type=template&id=585a181e&scoped=true&"
import script from "./OrderComplain.vue?vue&type=script&lang=ts&"
export * from "./OrderComplain.vue?vue&type=script&lang=ts&"
import style0 from "./OrderComplain.vue?vue&type=style&index=0&id=585a181e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585a181e",
  null
  
)

export default component.exports